export const botonDatos = function(){
  return {
    texto:"Agregar Personal",
    tipo:"btn-2",
    estilos:{ color: "#4e942e" },
    procesando:false,
    onClick:() => {
      console.log("click");
      // _f_.asignar(ev_u, { procesando_formulario: true });
      // _f_.asignar(ev_u, { mostrar_modal: true });
    }
  }
}
export const registro = function(){
  return {
    param: {
      // Dentro de los estilos van propiedades del componente
      //Cada elemento puede tener estilos
      // los elementos pueden ser div, input, etc. 
      // Si se desea agregar otro tipo de elemento que no esté en los componentes se puede agregar
      estilos:{columnas: "10% 10%"},
      elementos:[
        {texto:"{ e.texto }", tipo : "div", name:"d1", estilos : {}},
        {texto:"{ e.texto }", tipo : "div", name:"d1", estilos : {}}
      ],
    }}
}
export const tabla = function(){
  //estructura es la cabecera de la tabla
  //elementos son los registros de la tabla
  return {
    param: {
      estilos:{
        cabecera: [
          {tipo : "div", name:"d1", estilos : {ancho: "30%"}},
          {tipo : "div", name:"d2", estilos : {ancho: "30%"}},
        ],
        registros: [
          {tipo : "div", name:"d1", estilos : {}},
          {tipo : "div", name:"d2", estilos : {}},
        ]
      },
      elementos:{
        cabecera:[
          {texto:"columna1",  name:"d1"},
          {texto:"columna2", name:"d2"}
        ],
        registros:[
          {d1:"valor1col1", d2 : "valor1col2", id:"1"},
          {d1:"valor2col1", d2 : "valor2col2", id:"2"}
        ]
      },
    }
  }
}
export const tablaComprimido = function(){
  //estructura es la cabecera de la tabla
  //elementos son los registros de la tabla
  const estilosCabecera = [{tipo : "div", name:"d1", estilos : {ancho: "30%"}}, {tipo : "div", name:"d2", estilos : {ancho: "30%"}},]
  const estilosRegistros = [{tipo : "div", name:"d1", estilos : {}}, {tipo : "div", name:"d2", estilos : {}},]
  const elemtCabecera = {texto:"columna1",  name:"d1"}
  const elemtRegistro = {d1:"columna-d1", d2 : "columna-d2", id:"1"}
  const elementosCabecera = [elemtCabecera, elemtCabecera]
  const elementosRegistro = [elemtRegistro, elemtRegistro, elemtRegistro]
  const estilos = {cabecera: estilosCabecera, registros: estilosRegistros}
  const elementos = {cabecera: elementosCabecera, registros: elementosRegistro}
  return {
    param: {
      estilos: estilos,
      elementos: elementos,
    }}
}
export const bloqueTabla = function(){
  const elementosTabla = {
        cabecera:[
          {texto:"columna1",  name:"d1"},
          {texto:"columna2", name:"d2"}
        ],
        registros:[
          {d1:"valor1col1", d2 : "valor1col2", id:"1"},
          {d1:"valor2col1", d2 : "valor2col2", id:"2"}
        ]
      }
  const estilosTabla ={
      cabecera: [
          {tipo : "div", name:"d1", estilos : {ancho: "30%"}},
          {tipo : "div", name:"d2", estilos : {ancho: "30%"}},
        ],
      registros: [
        {tipo : "div", name:"d1", estilos : {}},
        {tipo : "div", name:"d2", estilos : {}},
      ]
  }
  const elementosRegistro =[
        {texto:"{ e.texto }", tipo : "div", name:"d1", estilos : {}},
        {texto:"{ e.texto }", tipo : "div", name:"d1", estilos : {}}
      ]
  return {
    param: {
      estilos:{titulo:"titulo"},
      elementos:[
        {texto: elementosTabla, tipo : "tabla", name:"tabla1", estilos : estilosTabla},
        {texto: elementosRegistro, tipo : "registro", name:"registro1", estilos : {columnas: "10% 10%"}},
        {texto: "Opciones", tipo : "opciones", name:"opciones1", estilos : {}},
      ],
    },
  }
}

export const listaBloques = function(){
  const registro = {d1:"valor2col1", d2 : "valor2col2", id:"2"}
  const registrosXcabecera = [registro,registro,registro,registro,registro,registro,registro,registro,registro,registro,registro,registro,registro,registro,registro,registro,registro,registro]
  
  const estilosTabla ={
      cabecera: [
          {texto:"columna1", tipo : "div", name:"d1", estilos : {ancho: "30%"}},
          {texto:"columna2", tipo : "div", name:"d2", estilos : {ancho: "30%"}},
        ],
      registros: [
        {tipo : "div", name:"d1", estilos : {}},
        {tipo : "div", name:"d2", estilos : {}},
      ]
  }
  const elementoBloque = {id:"1", categoria:"PANES X 24", elementos:registrosXcabecera}
  const elementosXbloque = [elementoBloque, elementoBloque, elementoBloque, elementoBloque, elementoBloque, elementoBloque, elementoBloque, elementoBloque]
  const elementosRegistro =[
        {texto:"{ e.texto }", tipo : "div", name:"d1", estilos : {}},
        {texto:"{ e.texto }", tipo : "div", name:"d1", estilos : {}}
  ]
  return {
    param: {
      texto: [{
        elementos:[
          elementosXbloque,
          {texto: elementosRegistro, tipo : "registro", name:"registro1", estilos : {columnas: "10% 10%"}},
          {texto: [], tipo : "opciones", name:"opciones1", estilos : {}},
        ],
        estilos: estilosTabla
      },{
        elementos:[
          elementosXbloque,
          {texto: elementosRegistro, tipo : "registro", name:"registro2", estilos : {columnas: "10% 10%"}},
          {texto: [], tipo : "opciones", name:"opciones1", estilos : {}},
        ],
        estilos: estilosTabla
      },{
        elementos:[
          elementoBloque,
          {texto: elementosRegistro, tipo : "registro", name:"registro3", estilos : {columnas: "10% 10%"}},
          {texto: [], tipo : "opciones", name:"opciones1", estilos : {}},
        ],
        estilos: estilosTabla
      }], tipo : "bloqueTabla", name: "listaBloque1", estilos : {columnas:3},
    }
  }
}
